import {
  CreateMemberRequest,
  DeleteMemberRequest,
  DownloadMemberExcelRequest,
  UpdateMemberRequest,
  ViewAllMembersRequest,
  ViewMemberProfileRequest,
  ViewMemberRequest,
  ViewTribeMembersRequest
} from './member.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/member`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateMemberRequest = (data: CreateMemberRequest): [string, HttpPostOptions<CreateMemberRequest>] => [
  getEndpoint(),
  getHttpPostOptions(data)
];

export const getViewAllMembersRequest = (data: ViewAllMembersRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/programme/${data.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getUpdateMemberRequest = (data: UpdateMemberRequest): [string, HttpPutOptions<UpdateMemberRequest>] => [
  getEndpoint(),
  getHttpPutOptions(data)
];

export const getDeleteMemberRequest = (data: DeleteMemberRequest): [string, HttpDeleteOptions] => [
  getSpecificEndpoint(data.memberExternalReference),
  getHttpDeleteOptions()
];

export const getDownloadMemberExcelRequest = (
  data: DownloadMemberExcelRequest
): [string, HttpPostOptions<DownloadMemberExcelRequest>] => [
  `${getEndpoint()}/excel/download/`,
  getHttpPostOptions(data)
];

export const getViewTribeMembersRequest = (data: ViewTribeMembersRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/tribe-members/${data.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getViewMemberRequest = (data: ViewMemberRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.memberExternalReference),
  getHttpGetOptions()
];

export const getViewMemberProfileRequest = (data: ViewMemberProfileRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.memberExternalReference)}/profile`,
  getHttpGetOptions()
];
